import defaultFetchServiceOverride from "app/common/services/salesFetchService";

import { createCrmEnrichmentAPIService } from "../../../../services/api/factory";

const dynamicsEnrichmentApiService = createCrmEnrichmentAPIService(defaultFetchServiceOverride, "dynamics");

export default dynamicsEnrichmentApiService;
